import React, { Suspense } from "react";

import { Outlet } from "react-router-dom";
import NewSideBar from "../global/NewSideBar";
import { Box, useTheme } from "@mui/material";
import MainAppBar from "../global/MainAppBar/MainAppBar";
import useDeviceType from "../global/Hooks/useDeviceType";
import { useDashboardModals } from "../../Context/DashboardModalsContext";
import MiniDrawer from '../../BScenes/Global/MiniDrawer/MiniDrawer';
import ResponsiveDrawer from '../../BScenes/Global/ResponsiveDrawer/ResponsiveDrawer'


const Dashboard = () => {
  const theme = useTheme();
  const deviceType = useDeviceType();
  const closOrderView = () => {
   setOrderView(false);
  };
  return (
    <Box sx={{ height: { md: "100vh", xs: "120vh" } }}>
      <div >
        {deviceType === "mobile" ? <ResponsiveDrawer /> : <MiniDrawer/>}
        <main
          className="content"
          style={{
            // background: theme.palette.mode === "dark" ? "#161B25" : "#F7FBFF",
            maxHeight: "100vh",
          }}
        >
        </main>
      </div>

    </Box>
  );
};

export default Dashboard;
